module.exports = __webpack_public_path__ + "static/img/soupe.6f7ebf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soupe.png
// module id = K7oc
// module chunks = 1